export const termsSections = [
  {
    title: 'Introducción y Aceptación',
    body:
      'Los presentes Términos y Condiciones (en adelante, el "Acuerdo") rigen el acceso y uso de la plataforma Beyond (en adelante, la "Aplicación"), propiedad de Beyond Limits Foundation (en adelante, "Beyond" o la "Empresa"), con domicilio en la República de Panamá. Al descargar, instalar o utilizar la Aplicación, el Usuario acepta de manera expresa y sin reservas todos los términos establecidos en este Acuerdo. Si el Usuario no está de acuerdo con estos términos, debe abstenerse de utilizar la Aplicación y proceder a su eliminación inmediata.',
  },
  {
    title: 'Naturaleza del Servicio y Exención de Responsabilidad Médica',
    body:
      'Beyond es una plataforma digital diseñada para conectar a usuarios con profesionales de la salud mental y bienestar para la prestación de servicios terapéuticos.',
    items: [
      'No es un servicio de emergencias: La Aplicación NO debe utilizarse en casos de crisis de salud mental, pensamientos suicidas o emergencias médicas de cualquier índole. En tales circunstancias, el Usuario debe contactar de inmediato a los servicios de emergencia locales (911 en Panamá) o acudir al centro de salud más cercano.',
      'Intermediación: Beyond actúa exclusivamente como facilitador tecnológico. Los profesionales que prestan servicios a través de la plataforma son contratistas independientes o terceros externos, responsables únicos de la calidad y ética de sus terapias. Beyond verifica que todos los profesionales de la salud mental registrados en la plataforma cuenten con su respectiva idoneidad profesional vigente expedida por el Consejo Técnico de Salud Pública de Panamá.',
      'Exención de Dispositivo Médico (SaMD): Esta aplicación es una plataforma de comunicación e intermediación. No es un dispositivo médico regulado por la FDA (Food and Drug Administration) ni por ninguna otra entidad regulatoria equivalente. La Aplicación no evalúa, diagnostica, previene ni trata condiciones médicas por sí misma a través de algoritmos o inteligencia artificial. Beyond no garantiza resultados específicos ni se hace responsable por diagnósticos o tratamientos emitidos por dichos profesionales.',
    ],
  },
  {
    title: 'Protección de Datos Personales (Cumplimiento Ley 81 de 2019)',
    body:
      'En cumplimiento con la Ley 81 del 26 de marzo de 2019 sobre Protección de Datos Personales de la República de Panamá, Beyond establece lo siguiente:',
    subsections: [
      {
        title: '3.1. Consentimiento Informado',
        body:
          'Al utilizar la Aplicación, el Usuario otorga su consentimiento previo, informado y expreso para el tratamiento de sus datos personales, incluyendo datos sensibles relacionados con su salud mental e historial clínico. Además, la Aplicación cumple con las políticas de contenido de salud y cuenta con los permisos necesarios para manejar información de salud mental según las normativas de las tiendas de aplicaciones.',
      },
      {
        title: '3.2. Finalidad del Tratamiento',
        body: 'Los datos se recolectan con el fin de:',
        items: [
          'Gestionar el registro y perfil del Usuario.',
          'Facilitar las sesiones de terapia y el seguimiento clínico.',
          'Procesar pagos y facturación.',
          'Cumplir con obligaciones legales ante las autoridades de salud de Panamá.',
        ],
      },
      {
        title: '3.3. Derechos ARCOP',
        body:
          'El Usuario puede ejercer sus derechos de Acceso, Rectificación, Cancelación, Oposición y Portabilidad enviando una solicitud a nuestro correo electrónico oficial: privacidad@beyondlimitsglobal.org o mediante correo postal a nuestra sede física en la Ciudad de Panamá. La eliminación de datos estará sujeta a los periodos de retención legal obligatorios para expedientes médicos en Panamá.',
      },
    ],
  },
  {
    title: 'Propiedad Intelectual y Protección de la Información',
    body:
      'Todo el contenido de la Aplicación, incluyendo pero no limitado a: código fuente, algoritmos, diseños, logotipos, textos, metodologías y estructuras de bases de datos, son propiedad exclusiva de Beyond Limits Foundation. Queda prohibida la ingeniería inversa, descompilación o copia total/parcial de la Aplicación. El uso no autorizado de la propiedad intelectual de Beyond será perseguido civil y penalmente bajo las leyes de derecho de autor de Panamá.',
  },
  {
    title: 'Políticas de Apple App Store y Google Play Store',
    subsections: [
      {
        title: '5.1. Exención de Responsabilidad de las Tiendas',
        body:
          'El Usuario reconoce que este Acuerdo es entre el Usuario y Beyond, no con Apple Inc. ni Google LLC. Apple y Google no tienen obligación de soporte ni mantenimiento para la Aplicación y no son responsables de ninguna reclamación relacionada con la misma.',
      },
      {
        title: '5.2. Pagos y Suscripciones',
        body:
          'Para los servicios de consultoría médica o terapia "uno a uno" en tiempo real, las transacciones se procesan mediante pasarelas de pago externas seguras, de conformidad con las excepciones de In-App Purchases de las plataformas. Si la Aplicación utiliza los sistemas de pago de Apple o Google para otros servicios, las transacciones se rigen por los términos de dichas plataformas. Las cancelaciones de suscripciones deben ser gestionadas por el Usuario directamente en la configuración de su cuenta de Apple ID o Google Play.',
      },
      {
        title: '5.3. Eliminación de Cuenta',
        body:
          'Conforme a las normativas de Apple y Google, el Usuario puede solicitar la eliminación de su cuenta directamente desde el menú de configuración de la Aplicación o mediante el enlace disponible en la ficha de la tienda virtual. Tras la solicitud, los datos personales no médicos serán eliminados de forma permanente.',
      },
    ],
  },
  {
    title: 'Política de Cancelaciones y Reembolsos (ACODECO)',
    body:
      'El Usuario tiene derecho a cancelar o reprogramar una cita con un mínimo de 24 horas de antelación para recibir un reembolso total o reagendamiento sin penalidad. Si el profesional de la salud asignado no asiste a la sesión programada, o si la sesión no puede llevarse a cabo debido a fallas técnicas comprobables en la Aplicación, el Usuario tendrá derecho a elegir entre la reprogramación de su cita o el reembolso íntegro del servicio pagado.',
  },
  {
    title: 'Contenido Generado por el Usuario y Conducta',
    body:
      'La Aplicación mantiene una política de tolerancia cero frente al acoso, lenguaje de odio o comportamiento abusivo. Para garantizar la seguridad, el Usuario cuenta con herramientas integradas en la Aplicación que le permiten reportar cualquier contenido inadecuado y bloquear a otros usuarios o profesionales directamente desde la plataforma. Beyond se reserva el derecho de expulsar permanentemente a cualquier Usuario que viole estas normas, sin previo aviso y sin derecho a reembolso en caso de incumplimiento de la convivencia.',
  },
  {
    title: 'Medidas de Seguridad',
    body:
      'Beyond garantiza el uso de encriptación y protocolos de seguridad de grado médico para proteger la información confidencial del Usuario durante su transmisión y almacenamiento.',
  },
  {
    title: 'Ley Aplicable y Jurisdicción',
    body:
      'Este Acuerdo se rige por las leyes de la República de Panamá. Cualquier controversia será resuelta ante los tribunales ordinarios de la Ciudad de Panamá.',
  },
];

export const termsFooter = 'Última actualización: Abril de 2026.';

export const privacySections = [
  {
    title: 'Protección de Datos Personales (Cumplimiento Ley 81 de 2019)',
    body:
      'En cumplimiento con la Ley 81 del 26 de marzo de 2019 sobre Protección de Datos Personales de la República de Panamá, Beyond Limits Foundation, propietaria de la plataforma Beyond, establece lo siguiente:',
  },
  {
    title: 'Consentimiento Informado',
    body:
      'Al utilizar la Aplicación, el Usuario otorga su consentimiento previo, informado y expreso para el tratamiento de sus datos personales, incluyendo datos sensibles relacionados con su salud mental e historial clínico. Además, la Aplicación cumple con las políticas de contenido de salud y cuenta con los permisos necesarios para manejar información de salud mental según las normativas de las tiendas de aplicaciones.',
  },
  {
    title: 'Finalidad del Tratamiento',
    body: 'Los datos se recolectan con el fin de:',
    items: [
      'Gestionar el registro y perfil del Usuario.',
      'Facilitar las sesiones de terapia y el seguimiento clínico.',
      'Procesar pagos y facturación.',
      'Cumplir con obligaciones legales ante las autoridades de salud de Panamá.',
    ],
  },
  {
    title: 'Derechos ARCOP',
    body:
      'El Usuario puede ejercer sus derechos de Acceso, Rectificación, Cancelación, Oposición y Portabilidad enviando una solicitud a nuestro correo electrónico oficial: privacidad@beyondlimitsglobal.org o mediante correo postal a nuestra sede física en la Ciudad de Panamá. La eliminación de datos estará sujeta a los periodos de retención legal obligatorios para expedientes médicos en Panamá.',
  },
  {
    title: 'Eliminación de Cuenta',
    body:
      'Conforme a las normativas de Apple y Google, el Usuario puede solicitar la eliminación de su cuenta directamente desde el menú de configuración de la Aplicación o mediante el enlace disponible en la ficha de la tienda virtual. Tras la solicitud, los datos personales no médicos serán eliminados de forma permanente.',
  },
  {
    title: 'Medidas de Seguridad',
    body:
      'Beyond garantiza el uso de encriptación y protocolos de seguridad de grado médico para proteger la información confidencial del Usuario durante su transmisión y almacenamiento.',
  },
];

export const privacyFooter = 'Última actualización: Abril de 2026.';
